import React, { FC } from "react";
import { useParams } from "react-router-dom";
import { Paths } from "../../../common/paths/paths";
import { getString } from "../../../common/uistringlabels/ui-string-utils";
import { OrderTrackingLayout } from "@/pages/OrderTracking/components/OrderTrackingLayout/order-tracking-layout";
import { toLcrTrackingView } from "@/pages/OrderTracking/Lcr/lcr-tracking-view.mapper";
import { useLcrOrder } from "@/pages/OrderTracking/Lcr/hooks/use-lcr-order.hook";

const LcrOrderTrackingPage: FC = () => {
  const { serialNumber } = useParams<{ serialNumber?: string }>();
  const { data: order, isLoading, isError, refetch } = useLcrOrder(serialNumber);

  return (
    <OrderTrackingLayout
      view={order ? toLcrTrackingView(order) : undefined}
      isLoading={isLoading}
      isError={isError}
      onRetry={() => refetch()}
      notFoundLink={{
        label: getString("orderTracking.notFoundLinks.yourOrders"),
        url: Paths.orders.url,
      }}
    />
  );
};

export default LcrOrderTrackingPage;
